document.addEventListener('DOMContentLoaded', function () {
  function getColorOption(variant) {
    if (!variant || !variant.options) return null;
    const product = window.__gzProductData;
    if (!product) return null;
    const colorIndex = product.options.findIndex(
      (o) => o.toLowerCase() === 'color'
    );
    if (colorIndex === -1) return null;
    return variant.options[colorIndex];
  }

  function filterGalleryByColor(color) {
    if (!color) return;
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    const allSlides = gallery.querySelectorAll('[id^="GalleryViewer"] li[data-media-id]');
    const allThumbs = gallery.querySelectorAll('[id^="GalleryThumbnails"] li[data-target]');

    allSlides.forEach((slide) => {
      const img = slide.querySelector('img');
      if (!img) return;
      const alt = img.getAttribute('alt') || '';
      if (alt.toLowerCase() === color.toLowerCase()) {
        slide.style.display = '';
      } else {
        slide.classList.remove('is-active');
        slide.style.display = 'none';
      }
    });

    allThumbs.forEach((thumb) => {
      const img = thumb.querySelector('img');
      if (!img) return;
      const alt = img.getAttribute('alt') || '';
      if (alt.toLowerCase() === color.toLowerCase()) {
        thumb.style.display = '';
      } else {
        thumb.style.display = 'none';
      }
    });

    const firstVisible = gallery.querySelector('[id^="GalleryViewer"] li[data-media-id]:not([style*="none"])');
    if (firstVisible) {
      firstVisible.classList.add('is-active');
      const mediaGallery = document.querySelector('media-gallery');
      if (mediaGallery && mediaGallery.setActiveMedia) {
        mediaGallery.setActiveMedia(firstVisible.dataset.mediaId, false);
      }
    }
  }

  // koristi isti subscribe sistem kao tema
  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      const color = getColorOption(event.data?.variant);
      if (color) filterGalleryByColor(color);
    });
  }

  // init na ucitavanju stranice
  const selectedVariantEl = document.querySelector('[data-selected-variant]');
  if (selectedVariantEl) {
    try {
      const variant = JSON.parse(selectedVariantEl.textContent);
      const color = getColorOption(variant);
      if (color) filterGalleryByColor(color);
    } catch (e) {}
  }
});
